import React, { useId } from 'react';
import { Link } from 'react-router-dom';
import { Field, Form, Formik } from 'formik';
import { ORDINE_SHORTLIST } from '../globals';

interface Props {
  threadId: number;
  savedVersion: number;
  modified: boolean;
}

const EsportaShortlist = ({ threadId, savedVersion, modified }: Props) => {
  const id = useId();
  return <section className="shortlist-section shortlist-exports" aria-labelledby={`${id}-heading`}>
    <div className="shortlist-section-heading">
      <h2 id={`${id}-heading`}>Esporta</h2>
      <span className="small text-muted">Download dalla versione salvata #{savedVersion}</span>
    </div>
    {modified && <p className="shortlist-export-notice">Le modifiche non salvate non sono incluse nei download.</p>}
    <div className="shortlist-export-grid">
      <section className="shortlist-export-group" aria-labelledby={`${id}-latex-heading`}>
        <h3 id={`${id}-latex-heading`}><i className="fa fa-download mr-2" aria-hidden="true" />LaTeX</h3>
        <Formik initialValues={{ order: 'ordine', rev: false }} onSubmit={() => {}}>
          {({ values }) => <Form aria-label="Download LaTeX">
            <label htmlFor={`${id}-order`}>Ordine di esportazione</label>
            <Field as="select" id={`${id}-order`} name="order" className="form-control form-control-sm">
              {ORDINE_SHORTLIST.map(option => <option key={option.id} value={option.id}>{option.display}</option>)}
            </Field>
            <label className="shortlist-inline-check"><Field name="rev" type="checkbox" />Inverti ordine</label>
            <a href={`/api/problems/shortlist/${threadId}/export/?order=${values.order}&rev=${values.rev}`}
              className="btn btn-sm btn-outline-primary">Scarica ZIP LaTeX</a>
          </Form>}
        </Formik>
      </section>
      <section className="shortlist-export-group" aria-labelledby={`${id}-overleaf-heading`}>
        <h3 id={`${id}-overleaf-heading`}><i className="fa fa-hammer mr-2" aria-hidden="true" />Overleaf</h3>
        <p className="small text-muted">Apri il progetto per il testo o per le soluzioni.</p>
        <div className="shortlist-export-links">
          <Link to={`/shortlist/build/${threadId}/testo/`} className="btn btn-sm btn-outline-primary">Apri testo</Link>
          <Link to={`/shortlist/build/${threadId}/soluzioni/`} className="btn btn-sm btn-outline-primary">Apri soluzioni</Link>
        </div>
      </section>
      <section className="shortlist-export-group" aria-labelledby={`${id}-answers-heading`}>
        <h3 id={`${id}-answers-heading`}><i className="fa fa-list mr-2" aria-hidden="true" />Risposte</h3>
        <Formik initialValues={{ evento: 1, tipologia: 'gas' }} onSubmit={() => {}}>
          {({ values }) => <Form aria-label="Export risposte">
            <div className="shortlist-answer-fields">
              <div><label htmlFor={`${id}-format`}>Destinazione</label>
                <Field as="select" name="tipologia" id={`${id}-format`} className="form-control form-control-sm">
                  <option value="gas">Gascal</option><option value="preteststage">Pretest stage</option>
                </Field>
              </div>
              <div><label htmlFor={`${id}-event`}>ID evento di destinazione</label>
                <Field name="evento" type="number" step={1} id={`${id}-event`} className="form-control form-control-sm" />
              </div>
            </div>
            <p className="small text-muted my-2">Usa l’ID previsto dal sistema di destinazione.</p>
            <a href={`/api/problems/shortlist/${threadId}/${values.tipologia === 'gas' ? 'export_risposte_gascal' : 'export_risposte_stagefisica'}/?evento=${values.evento}`}
              className="btn btn-sm btn-outline-primary">Esporta risposte</a>
          </Form>}
        </Formik>
      </section>
    </div>
  </section>;
};

export default EsportaShortlist;
